import requestFields from '../../common/constants/requestFields'
import { propertyDetailSearchFields, propertyTransactionsFields, realEstateGeneralFields } from '../../common/forms/generalRealEstate/fields'

export const PROPERTY_VALUE_ENDPOINTS = {
    // General tab endpoints
    propertyService: 'v1/property/values/propertyService',
    propertyType: 'v1/property/values/propertyType',
    propertySubtype: 'v1/property/values/propertySubType',
    supplySource: 'v1/property/values/propertySupplySource',
    position: 'v1/property/values/propertyPosition',
    houseType: 'v1/property/values/propertyHouseType',
    roomsNo: 'v1/property/values/propertyRoomsNo',
    floor: 'v1/property/values/propertyFloor',
    floorPosition: 'v1/property/values/propertyFloorPosition',
    orientation: 'v1/property/values/propertyOrientation',
    heating: 'v1/property/values/propertyHeating',
    condition: 'v1/property/values/propertyCondition',
    windowsDoors: 'v1/property/values/propertyWindowsDoors',
    publicTransportation: 'v1/property/values/propertyPublicTransportation',
    specialFeature: 'v1/property/values/propertySpecialFeature',
    utility: 'v1/property/values/propertyUtility',
    equipment: 'v1/property/values/propertyEquipment',
    space: 'v1/property/values/propertySpace',
    energyEfficiency: 'v1/property/values/propertyEnergyEfficiency',
    access: 'v1/property/values/propertyAccess',
    permit: 'v1/property/values/propertyPermit',
    agencyCommission: 'v1/property/values/agencyCommission',
    descriptions: 'v1/property/values/propertyDescriptions',
    dataSource: 'v1/property/values/dataSource',
    primaryUsage: 'v1/property/values/propertyPrimaryUsage',
    landUsage: 'v1/property/values/propertyLandUsage',

    // Transactions tab endpoints
    status: 'v1/property/values/propertyStatus',
    transactionRiskDegree: 'v1/property/values/propertyTransactionRiskDegree',
    mainRegister: 'v1/property/values/propertyMainRegister',
    mainRegisterDepartment: 'v1/property/values/propertyMainRegisterDepartment',
    puk: 'v1/property/values/propertyPuk',
    pukDepartment: 'v1/property/values/propertyPukDepartment',
    registryDepartmentKpu: 'v1/property/values/propertyRegistryDepartmentKpu',
    registryDepartmentKpuSubinsert: 'v1/property/values/propertyRegistryDepartmentKpuSubinsert',
    landRegistryStatus: 'v1/property/values/propertyLandRegistryStatus',
    ownershipAcquisition: 'v1/property/values/propertyOwnershipAcquisition',
    ownershipAcquisitionProof: 'v1/property/values/propertyOwnershipAcquisitionProof',
    cadastralMunicipality: 'v1/property/values/propertyCadastralMunicipality', // SLO market only
} as const

// Property General form field mappings
export const propertyGeneralFieldsConfig = {
    propertyService: realEstateGeneralFields.PROPERTY_SERVICE_ID,
    propertyType: realEstateGeneralFields.PROPERTY_TYPE_ID,
    propertySubtype: realEstateGeneralFields.PROPERTY_SUB_TYPE_ID,
    supplySource: requestFields.PROPERTY_SUPPLY_SOURCE_ID,
    position: realEstateGeneralFields.PROPERTY_POSITION_ID,
    houseType: realEstateGeneralFields.PROPERTY_HOUSE_TYPE_ID,
    roomsNo: realEstateGeneralFields.PROPERTY_ROOMS_NO_ID,
    floor: realEstateGeneralFields.PROPERTY_FLOOR_ID,
    floorPosition: realEstateGeneralFields.PROPERTY_FLOOR_POSITION_ID,
    orientation: realEstateGeneralFields.PROPERTY_ORIENTATION_ID,
    heating: realEstateGeneralFields.PROPERTY_HEATING_ID,
    condition: realEstateGeneralFields.PROPERTY_CONDITION_ID,
    windowsDoors: realEstateGeneralFields.PROPERTY_WINDOWS_DOORS_ID,
    publicTransportation: realEstateGeneralFields.PROPERTY_PUBLIC_TRANSPORTATION_ID,
    specialFeature: realEstateGeneralFields.PROPERTY_SPECIAL_FEATURE_ID,
    utility: realEstateGeneralFields.PROPERTY_UTILITY_ID,
    equipment: realEstateGeneralFields.PROPERTY_EQUIPMENT_ID,
    space: realEstateGeneralFields.PROPERTY_SPACE_ID,
    energyEfficiency: realEstateGeneralFields.PROPERTY_ENERGY_EFFICIENCY_ID,
    access: realEstateGeneralFields.PROPERTY_ACCESS_ID,
    permit: realEstateGeneralFields.PROPERTY_PERMIT_ID,
    agencyCommission: realEstateGeneralFields.AGENCY_COMMISSION_ID,
    descriptions: realEstateGeneralFields.PROPERTY_DESCRIPTION,
    dataSource: realEstateGeneralFields.DATA_SOURCE_ID,
    primaryUsage: realEstateGeneralFields.PROPERTY_PRIMARY_USAGE_ID,
    landUsage: realEstateGeneralFields.PROPERTY_LAND_USAGE_ID,
}

// Property Transactions form field mappings
export const propertyTransactionsFieldsConfig = {
    status: propertyTransactionsFields.PROPERTY_STATUS_ID,
    transactionRiskDegree: propertyTransactionsFields.PROPERTY_TRANSACTION_RISK_DEGREE_ID,
    mainRegister: propertyTransactionsFields.PROPERTY_MAIN_REGISTER_ID,
    mainRegisterDepartment: propertyTransactionsFields.PROPERTY_MAIN_REGISTER_DEPARTMENT_ID,
    puk: propertyTransactionsFields.PROPERTY_PUK_ID,
    pukDepartment: propertyTransactionsFields.PROPERTY_PUK_DEPARTMENT_ID,
    registryDepartmentKpu: propertyTransactionsFields.PROPERTY_REGISTRY_DEPARTMENT_KPU_ID,
    registryDepartmentKpuSubinsert: propertyTransactionsFields.PROPERTY_REGISTRY_DEPARTMENT_KPU_SUBINSERT_ID,
    landRegistryStatus: propertyTransactionsFields.PROPERTY_LAND_REGISTRY_STATUS_ID,
    ownershipAcquisition: propertyTransactionsFields.PROPERTY_OWNERSHIP_ACQUISITION_ID,
    ownershipAcquisitionProof: propertyTransactionsFields.PROPERTY_OWNERSHIP_ACQUISITION_PROOF_ID,
    cadastralMunicipality: propertyTransactionsFields.PROPERTY_CADASTRAL_MUNCIPALITY,
}

// Property Detail Search form field mappings
export const propertyDetailSearchFieldsConfig = {
    propertyService: propertyDetailSearchFields.PROPERTY_SERVICE,
    propertyType: propertyDetailSearchFields.PROPERTY_TYPE,
    propertySubtype: propertyDetailSearchFields.PROPERTY_SUB_TYPE,
    status: propertyDetailSearchFields.PROPERTY_STATUS,
    energyEfficiency: propertyDetailSearchFields.PROPERTY_ENERGY_EFFICIENCY,
    condition: propertyDetailSearchFields.PROPERTY_CONDITION,
    descriptions: propertyDetailSearchFields.PROPERTY_DESCRIPTIONS,
    utility: propertyDetailSearchFields.PROPERTY_UTILITY,
    equipment: propertyDetailSearchFields.PROPERTY_EQUIPMENT,
    space: propertyDetailSearchFields.PROPERTY_SPACE,
    floor: propertyDetailSearchFields.PROPERTY_FLOOR,
}

export const ENDPOINT_FILTERS: Record<string, string[]> = {
    propertySubtype: ['propertyType'],
    floor: ['propertyType'],
    heating: ['propertyType'],
    condition: ['propertyType'],
    utility: ['propertyType'],
    equipment: ['propertyType'],
    space: ['propertyType'],
    primaryUsage: ['propertyType'],
    agencyCommission: ['propertyService'],
    descriptions: ['propertyType', 'propertyService'],
    permit: ['propertyType', 'propertyService'],
    mainRegisterDepartment: ['propertyMainRegister'],
    registryDepartmentKpuSubinsert: ['propertyRegistryDepartmentKpu'],
}

export const MARKET_SPECIFIC_FIELDS: Record<string, string[]> = {
    Slovenija: ['cadastralMunicipality'],
}
